 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"404":"404","branches":"branches","branding":"branding","channel-factor":"channel-factor","register-customer":"register-customer","ssa-customer":"ssa-customer","dashboard-activity~dashboard-reporting~system-logs":"dashboard-activity~dashboard-reporting~system-logs","dashboard-reporting":"dashboard-reporting","access":"access","public-registration-record-video~upload-document":"public-registration-record-video~upload-document","public-registration-record-video":"public-registration-record-video","upload-document":"upload-document","account-info":"account-info","additional-info":"additional-info","finish":"finish","public-registration-account-info":"public-registration-account-info","public-registration-setup-profile":"public-registration-setup-profile","public-registration-upload-document":"public-registration-upload-document","setup-profile":"setup-profile","system-users":"system-users","view-alerts":"view-alerts","dashboard-activity":"dashboard-activity","system-logs":"system-logs","configuration":"configuration","contact-us":"contact-us","country":"country","country-type":"country-type","customer":"customer","data-type":"data-type","deceased":"deceased","descprition-1":"descprition-1","descprition-2":"descprition-2","descprition-3":"descprition-3","document-verification-factor":"document-verification-factor","forgot-password":"forgot-password","gender":"gender","idenfo-engine":"idenfo-engine","identification":"identification","industry":"industry","login":"login","name-screen-score":"name-screen-score","name-type":"name-type","nationality":"nationality","occupation":"occupation","on-boarding-configuration":"on-boarding-configuration","productFactor":"productFactor","public-register-customer":"public-register-customer","public-ssa-customer":"public-ssa-customer","purpose-of-action":"purpose-of-action","record-status":"record-status","relationship-factor":"relationship-factor","relationship-type":"relationship-type","reset-password":"reset-password","risk-factor":"risk-factor","risk-level-review":"risk-level-review","risk-rating":"risk-rating","role-type":"role-type","roles":"roles","sanction-reference":"sanction-reference","screening-data":"screening-data","simulate":"simulate","state":"state","work":"work","world-check-EIType":"world-check-EIType","world-check-category":"world-check-category","world-check-deceased":"world-check-deceased","world-check-keyword":"world-check-keyword","world-check-location":"world-check-location","world-check-sub-category":"world-check-sub-category","world-check-update-category":"world-check-update-category"}[chunkId]||chunkId) + "." + {"404":"3630437a","branches":"b707454f","branding":"42540ce7","channel-factor":"1096f137","chunk-0e4095e0":"d9b1ef65","chunk-2d0ac03f":"3ab23064","chunk-20520a44":"9b77b02c","register-customer":"b32d2149","ssa-customer":"bf1eb35c","chunk-1acbbf1c":"b290427e","chunk-20bef806":"bdd2e7f7","chunk-2228a6de":"fa89af3d","chunk-2b81102a":"4c7b2c66","dashboard-activity~dashboard-reporting~system-logs":"2e204742","dashboard-reporting":"cd0cd060","chunk-2d0a2dd2":"37f01074","chunk-2d0a34dd":"2c83fd4f","chunk-2d0bd416":"7e968383","chunk-2d0cbf12":"ab804a9c","chunk-2d0e97b4":"10a5be69","access":"76ce6538","public-registration-record-video~upload-document":"c9ad0335","public-registration-record-video":"bcf730c1","upload-document":"d9ee0835","chunk-2d22fd71":"9ada0df9","account-info":"8e31d8bf","additional-info":"4201b708","finish":"e25e91d7","public-registration-account-info":"78c9bca5","public-registration-setup-profile":"37d8ad2c","public-registration-upload-document":"67d01dce","setup-profile":"caa5beab","chunk-76fde123":"372bfef8","chunk-59747d21":"9f08922e","chunk-405b7130":"84c332d3","system-users":"2c73bd86","chunk-062c837c":"c1ec66c5","chunk-2d0dd7ae":"884b8dcc","view-alerts":"57059869","dashboard-activity":"a849b446","system-logs":"c1ab8d82","chunk-2d2384d6":"8ac211c9","chunk-326bdc82":"a4bc1073","chunk-326f5bbf":"bff546a6","chunk-32bc38d4":"37bc34ab","chunk-42420a72":"db435416","chunk-910149de":"c7dce54b","chunk-f150845c":"bee97ba4","chunk-607e77cd":"8b02bbca","chunk-9df2555e":"84dd142d","chunk-19357db2":"f9ed9dfc","chunk-1e8266f8":"d943d87c","chunk-2d0b99a6":"2ac18741","chunk-38d011e1":"06e2325b","chunk-40c91b52":"aaa9c407","chunk-735ed995":"74febe10","chunk-b5536b38":"1e5e82a3","chunk-c543a044":"9822c4f0","configuration":"43878f92","contact-us":"a8128fbe","country":"dcd9bae9","country-type":"1d272a14","customer":"96620343","data-type":"3c39a4ef","deceased":"c2d5ce61","descprition-1":"b2f04dca","descprition-2":"27a9c772","descprition-3":"e78e2ce8","document-verification-factor":"38f60a32","forgot-password":"1a4023b1","gender":"68208550","idenfo-engine":"0dc607da","identification":"b577675a","industry":"8b78c9dc","login":"706af91a","name-screen-score":"724f04f7","name-type":"69f8e88d","nationality":"a4791dc6","occupation":"d2b9442c","on-boarding-configuration":"53352533","productFactor":"91861396","public-register-customer":"996e2654","public-ssa-customer":"d99a1636","purpose-of-action":"dd014d96","record-status":"a80f80ea","relationship-factor":"2ad47d8f","relationship-type":"5b9f4d6b","reset-password":"ea81b8d1","risk-factor":"badc531a","risk-level-review":"f6a99530","risk-rating":"eedc95eb","role-type":"0a407945","roles":"380fbf0c","sanction-reference":"4e53a2d1","screening-data":"de2e01df","simulate":"94aaff98","state":"2c081a19","work":"5192ed33","world-check-EIType":"b68ca459","world-check-category":"ce0a2c26","world-check-deceased":"b6c02f29","world-check-keyword":"8820b234","world-check-location":"8cb2bce9","world-check-sub-category":"b65b7ae4","world-check-update-category":"fb354bbc"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"register-customer":1,"ssa-customer":1,"chunk-1acbbf1c":1,"chunk-20bef806":1,"chunk-2228a6de":1,"public-registration-record-video~upload-document":1,"public-registration-record-video":1,"upload-document":1,"additional-info":1,"finish":1,"public-registration-account-info":1,"public-registration-setup-profile":1,"public-registration-upload-document":1,"setup-profile":1,"chunk-76fde123":1,"chunk-062c837c":1,"chunk-32bc38d4":1,"chunk-42420a72":1,"chunk-910149de":1,"chunk-f150845c":1,"chunk-19357db2":1,"chunk-38d011e1":1,"chunk-c543a044":1,"industry":1,"login":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"404":"404","branches":"branches","branding":"branding","channel-factor":"channel-factor","register-customer":"register-customer","ssa-customer":"ssa-customer","dashboard-activity~dashboard-reporting~system-logs":"dashboard-activity~dashboard-reporting~system-logs","dashboard-reporting":"dashboard-reporting","access":"access","public-registration-record-video~upload-document":"public-registration-record-video~upload-document","public-registration-record-video":"public-registration-record-video","upload-document":"upload-document","account-info":"account-info","additional-info":"additional-info","finish":"finish","public-registration-account-info":"public-registration-account-info","public-registration-setup-profile":"public-registration-setup-profile","public-registration-upload-document":"public-registration-upload-document","setup-profile":"setup-profile","system-users":"system-users","view-alerts":"view-alerts","dashboard-activity":"dashboard-activity","system-logs":"system-logs","configuration":"configuration","contact-us":"contact-us","country":"country","country-type":"country-type","customer":"customer","data-type":"data-type","deceased":"deceased","descprition-1":"descprition-1","descprition-2":"descprition-2","descprition-3":"descprition-3","document-verification-factor":"document-verification-factor","forgot-password":"forgot-password","gender":"gender","idenfo-engine":"idenfo-engine","identification":"identification","industry":"industry","login":"login","name-screen-score":"name-screen-score","name-type":"name-type","nationality":"nationality","occupation":"occupation","on-boarding-configuration":"on-boarding-configuration","productFactor":"productFactor","public-register-customer":"public-register-customer","public-ssa-customer":"public-ssa-customer","purpose-of-action":"purpose-of-action","record-status":"record-status","relationship-factor":"relationship-factor","relationship-type":"relationship-type","reset-password":"reset-password","risk-factor":"risk-factor","risk-level-review":"risk-level-review","risk-rating":"risk-rating","role-type":"role-type","roles":"roles","sanction-reference":"sanction-reference","screening-data":"screening-data","simulate":"simulate","state":"state","work":"work","world-check-EIType":"world-check-EIType","world-check-category":"world-check-category","world-check-deceased":"world-check-deceased","world-check-keyword":"world-check-keyword","world-check-location":"world-check-location","world-check-sub-category":"world-check-sub-category","world-check-update-category":"world-check-update-category"}[chunkId]||chunkId) + "." + {"404":"31d6cfe0","branches":"31d6cfe0","branding":"31d6cfe0","channel-factor":"31d6cfe0","chunk-0e4095e0":"31d6cfe0","chunk-2d0ac03f":"31d6cfe0","chunk-20520a44":"31d6cfe0","register-customer":"73886f19","ssa-customer":"73886f19","chunk-1acbbf1c":"f3de5b15","chunk-20bef806":"5581a8b6","chunk-2228a6de":"7dfb08f7","chunk-2b81102a":"31d6cfe0","dashboard-activity~dashboard-reporting~system-logs":"31d6cfe0","dashboard-reporting":"31d6cfe0","chunk-2d0a2dd2":"31d6cfe0","chunk-2d0a34dd":"31d6cfe0","chunk-2d0bd416":"31d6cfe0","chunk-2d0cbf12":"31d6cfe0","chunk-2d0e97b4":"31d6cfe0","access":"31d6cfe0","public-registration-record-video~upload-document":"2149d945","public-registration-record-video":"ccd81013","upload-document":"b3a71b9a","chunk-2d22fd71":"31d6cfe0","account-info":"31d6cfe0","additional-info":"73886f19","finish":"a1361028","public-registration-account-info":"73886f19","public-registration-setup-profile":"73886f19","public-registration-upload-document":"d3c37496","setup-profile":"02661c86","chunk-76fde123":"5557fef5","chunk-59747d21":"31d6cfe0","chunk-405b7130":"31d6cfe0","system-users":"31d6cfe0","chunk-062c837c":"48adc48f","chunk-2d0dd7ae":"31d6cfe0","view-alerts":"31d6cfe0","dashboard-activity":"31d6cfe0","system-logs":"31d6cfe0","chunk-2d2384d6":"31d6cfe0","chunk-326bdc82":"31d6cfe0","chunk-326f5bbf":"31d6cfe0","chunk-32bc38d4":"16b99180","chunk-42420a72":"1087b6a3","chunk-910149de":"1087b6a3","chunk-f150845c":"db943fdd","chunk-607e77cd":"31d6cfe0","chunk-9df2555e":"31d6cfe0","chunk-19357db2":"0e136c73","chunk-1e8266f8":"31d6cfe0","chunk-2d0b99a6":"31d6cfe0","chunk-38d011e1":"e935173d","chunk-40c91b52":"31d6cfe0","chunk-735ed995":"31d6cfe0","chunk-b5536b38":"31d6cfe0","chunk-c543a044":"88f0feac","configuration":"31d6cfe0","contact-us":"31d6cfe0","country":"31d6cfe0","country-type":"31d6cfe0","customer":"31d6cfe0","data-type":"31d6cfe0","deceased":"31d6cfe0","descprition-1":"31d6cfe0","descprition-2":"31d6cfe0","descprition-3":"31d6cfe0","document-verification-factor":"31d6cfe0","forgot-password":"31d6cfe0","gender":"31d6cfe0","idenfo-engine":"31d6cfe0","identification":"31d6cfe0","industry":"b8c388fb","login":"d0256169","name-screen-score":"31d6cfe0","name-type":"31d6cfe0","nationality":"31d6cfe0","occupation":"31d6cfe0","on-boarding-configuration":"31d6cfe0","productFactor":"31d6cfe0","public-register-customer":"31d6cfe0","public-ssa-customer":"31d6cfe0","purpose-of-action":"31d6cfe0","record-status":"31d6cfe0","relationship-factor":"31d6cfe0","relationship-type":"31d6cfe0","reset-password":"31d6cfe0","risk-factor":"31d6cfe0","risk-level-review":"31d6cfe0","risk-rating":"31d6cfe0","role-type":"31d6cfe0","roles":"31d6cfe0","sanction-reference":"31d6cfe0","screening-data":"31d6cfe0","simulate":"31d6cfe0","state":"31d6cfe0","work":"31d6cfe0","world-check-EIType":"31d6cfe0","world-check-category":"31d6cfe0","world-check-deceased":"31d6cfe0","world-check-keyword":"31d6cfe0","world-check-location":"31d6cfe0","world-check-sub-category":"31d6cfe0","world-check-update-category":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
